export default __webpack_public_path__ + "static/media/landing_any_data_system.b13dabb0.jpg";